import AuthManager from 'utils/auth/authManager';

export default function authErrorResponseInterceptor(error: any) {
  if (error.response && error.response.status === 401) {
    AuthManager.removeToken();
  }

  return Promise.reject(error);
}
